import { CalendarStar } from "@phosphor-icons/react";

/**
 * Iter 85.41 · Small brass "Activity" pill for note tiles.
 *
 * Renders when a Meeting Note carries an `activity_briefing_id` so
 * partners spot the linkage at a glance across every note surface
 * (Advisory Desk feed, ClientDetail Notes tab, EngagementNotesTab).
 *
 * The pill is intentionally minimal — the full activity title lands in
 * a native `title` tooltip so hover reveals context without stealing
 * horizontal space from the note title row.
 *
 * @param {string}         activityId       The referenced activity_briefing note id.
 * @param {Map|Object}     activityTitleBy  Optional lookup (Map or plain object)
 *                                          keyed by note id → title. When the
 *                                          activity is present in the caller's
 *                                          note list, the pill's tooltip shows
 *                                          the discrete activity's title.
 * @param {string}         className        Extra classes for the pill wrapper.
 * @param {string}         testidSuffix     Data-testid suffix for reliable
 *                                          Playwright selectors from any surface.
 */
export default function ActivityPill({ activityId, activityTitleBy, className = "", testidSuffix }) {
  if (!activityId) return null;
  let tooltip = "Linked to a client activity";
  if (activityTitleBy) {
    const t = activityTitleBy instanceof Map
      ? activityTitleBy.get(activityId)
      : activityTitleBy[activityId];
    if (t) tooltip = `Activity · ${t}`;
  }
  return (
    <span
      title={tooltip}
      data-testid={testidSuffix ? `activity-pill-${testidSuffix}` : "activity-pill"}
      className={`inline-flex items-center gap-1 border border-brass/60 text-brass px-1.5 py-0.5 leading-none ${className}`}
    >
      <CalendarStar size={10} weight="fill" />
      Activity
    </span>
  );
}
